import { RefState } from './ref-state';
import * as urlParse from 'url-parse';

export class AdState {
    private isOrganic: boolean;
    private refState: RefState;

    public constructor(refState: RefState) {
        this.refState = refState;
        const parsedRefQuery = urlParse(`?${this.refState.refQueryString}`, true);
        this.isOrganic = parsedRefQuery.query.ads_group !== 'ads';
    }

    public getIsOrganic(): boolean {
        return this.isOrganic;
    }
}
